import classNames from 'classnames'
import { Image } from '~/components/Image'
import { SectionContainer } from '~/components/SectionContainer'
import { getImageSrcSet } from '~/helpers'
import ImageOverlayLinks from '../../components/ImageOverlayLinks/ImageOverlayLinks'
import styles from './FullWidthImage.module.scss'
import { FullWidthImageProps } from './FullWidthImage.types'

export const FullWidthImage = ({
  desktopImage,
  mobileImage,
  tabletImage,
  width = 'narrow',
  title,
  topPadding,
  mobileImageBreakpoint,
  tabletImageBreakpoint,
}: FullWidthImageProps) => {
  const mobileImg = mobileImage || tabletImage || desktopImage
  const tabletImg = tabletImage || desktopImage || mobileImage
  const desktopImg = desktopImage || tabletImage || mobileImage
  const formattedTitle = title?.replace(/ /g, '_')
  const elementId = `fullwidth-image-${formattedTitle}`
  const imageWrapperStyle = {
    '--image-wrapper-top-padding': topPadding || 'var(--spacing-20px)',
  } as React.CSSProperties

  return (
    <SectionContainer
      width={width}
      wrapperClassName={classNames('overflow-hidden', {
        'rounded-md': topPadding !== '0px',
      })}>
      <div
        id={elementId}
        style={imageWrapperStyle}
        className={classNames('relative', styles.imageWrapper)}>
        {desktopImage && (
          <>
            <ImageOverlayLinks
              desktopImage={desktopImage}
              tabletImage={tabletImage}
              mobileImage={mobileImage}
            />
            <Image
              src={desktopImg.src}
              addSrcSet={false}
              sources={
                <>
                  <source
                    srcSet={getImageSrcSet(mobileImg.src, [
                      { intrinsicImageSize: '700', width: '700' },
                    ])}
                    media={mobileImageBreakpoint}
                  />
                  <source
                    srcSet={getImageSrcSet(tabletImg.src, [
                      { intrinsicImageSize: '1000', width: '1000' },
                    ])}
                    media={tabletImageBreakpoint}
                  />
                </>
              }
              alt={desktopImg.altText}
              width={desktopImage.width}
              height={desktopImage.height}
            />
          </>
        )}
      </div>
    </SectionContainer>
  )
}
